'use strict'

import $ from 'jquery';

module.exports = function($element, options){
  var $el = $($element);
  if(!$el.length){
    return;
  }
  let offsetTop = (options && typeof(options.offsetTop) !== 'undefined' ? options.offsetTop : 15);
  let targetTop = $el.offset().top + offsetTop;
  $('html, body').animate({scrollTop: targetTop}, {
    duration: 500,
    easing: 'swing',
    complete: function(){
      $el.get(0).focus()
    }
  });
}
